import apiClient from '../console_services/ApiClient';
import UserDetailsServices from '../console_services/LoginLogot';
import { redirectToLoginPage } from '../../helper';

const FilterServices = {
  getFilters: async (params, instance) => {
    try {
      return (await apiClient.post('/fetchfilteroptions', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },
  savedFilters: async (params, instance) => {
    try {
      return (await apiClient.post('/saveFilterData', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },
  updateFilter: async (params, instance) => {
    try {
      return (await apiClient.post('/updateFilter', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },

  getAllSavedFilters: async (params, instance) => {
    try {
      return (await apiClient.get('/getAllSavedFilters', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },
  deleteSavedFilters: async (_id, instance) => {
    try {
      const response = await apiClient.post('/deleteFilter?id=${id}');
      return response.data;
    } catch (error) {
      console.error('Error deleting filter:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },
};

export default FilterServices;
